import { useQuery } from "@tanstack/react-query";
import { getAuthenticationProvider } from "@/modules/authentication/actions/get-authentication-provider";

export function useAuthenticationProviderQuery() {
    return useQuery({
        queryKey: ["authentication-provider"],
        queryFn: async () => await getAuthenticationProvider(),
    });
}
